module.exports = __webpack_public_path__ + "img/check-silver-circle.24f07b6e.svg";